import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  table: {
    width: '100%',
    color: '#2A2626',
    margin: 0,
    padding: 0,
  },
  tableRow: {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-start',
    alignContent: 'stretch',
    borderTopWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightWidth: 1,
  },
  tallRow: {
    height: 40,
  },
  tallRowText: {
    lineHeight: 1.2,
  },
  fixedRow: {
    flexWrap: 'nowrap',
    height: 30,
  },
  expandingRow: {
    flexWrap: 'wrap',
  },
  partialBorderRow: {
    borderColor: '#979797',
    borderLeftWidth: 1,
  },
  fullBorderRow: {
    borderColor: '#333333',
  },
  tableCol: {
    margin: 0,
    lineHeight: 0,
    borderStyle: 'solid',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: 1,
    alignItems: 'center',
    alignContent: 'center',
    paddingVertical: 2,
    paddingHorizontal: 5,
  },
  fullBorderCol: {
    borderColor: '#333333',
    borderLeftWidth: 1,
  },
  alignCenter: {
    justifyContent: 'center',
    textAlign: 'center',
  },
  alignLeft: {
    justifyContent: 'flex-start',
    textAlign: 'left',
  },
  tableCellValueCenter: {
    alignSelf: 'center',
  },
  tableCellValueLeft: {
    alignSelf: 'flex-start',
  },
  tableTitleContainer: {
    alignItems: 'center',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: '#979797',
    height: 16,
    maxHeight: 16,
    minHeight: 16,
    paddingLeft: 5,
  },
  tableTitle: {
    fontSize: 8,
  },
  text: {
    fontFamily: 'MaisonNeue',
    lineHeight: 1.2,
  },
  bold: {
    fontFamily: 'MaisonNeue-Bold',
    lineHeight: 1.2,
  },
  italic: {
    fontFamily: 'MaisonNeue-BookItalic',
    fontStyle: 'italic',
    lineHeight: 1.2,
  },
});

export default styles;
